import angular from 'angular';

let whenScrolledModule = angular.module('shared.components.whenScrolled',[])
  .directive('whenScrolled', whenScrolled);

function whenScrolled(){

}

whenScrolled.$inject = [];
export default whenScrolledModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/when-scrolled/when-scrolled.js
 **/